import { useIntl } from "react-intl";

import { IconCheck } from "@/components/Icons";
import type { AdditionalServiceData } from "@/features/flights/types/types";
import type { GetFlightAvailabilityTokenAdditionalServiceV2 } from "@/types/codegen";
import {
  SUPPORTED_BAGGAGE_ADDITIONAL_SERVICES_CODES,
  SUPPORTED_MEAL_ADDITIONAL_SERVICES_CODES,
} from "@/utils/constants";

type Props = {
  selectedServices: AdditionalServiceData[];
  services?: GetFlightAvailabilityTokenAdditionalServiceV2[];
};
export const AdditionalServicesCheckoutOverview = ({
  selectedServices,
  services,
}: Props) => {
  const intl = useIntl();
  return (
    <div className="flex flex-col gap-2">
      <span className="text-sm font-semibold text-text-primary">
        {intl.formatMessage({
          defaultMessage: "Extra services",
          description:
            "Title of additional services overview in flight order summary",
        })}
      </span>
      {selectedServices.map((service) => {
        const foundService = services?.find(
          (s) => s.bookingCode === service.service.bookingCode,
        );
        const selectedOption = foundService?.options.find(
          (option) => option.code === service.service.selectedOptionCode,
        );

        const serviceNameLabel = foundService
          ? `${foundService.service.name}`
          : null;
        const optionNameLabel = selectedOption
          ? ` - ${selectedOption.description}`
          : null;

        return (
          <div className="flex gap-1" key={service.service.bookingCode}>
            <IconCheck className="size-6 shrink-0" />
            <div className="flex flex-col gap-0.5 text-sm font-normal">
              {SUPPORTED_MEAL_ADDITIONAL_SERVICES_CODES.includes(
                service.categoryCode,
              ) ? (
                <span className="text-text-primary">
                  {intl.formatMessage({
                    defaultMessage: "Meal selected",
                    description:
                      "Label informing user about selected meal in flight order summary",
                  })}
                </span>
              ) : null}

              {SUPPORTED_BAGGAGE_ADDITIONAL_SERVICES_CODES.includes(
                service.categoryCode,
              ) ? (
                <span className="text-text-primary">
                  {intl.formatMessage({
                    defaultMessage: "Baggage selected",
                    description:
                      "Label informing user about selected baggage in flight order summary",
                  })}
                </span>
              ) : null}

              <span className="text-text-tertiary">
                {serviceNameLabel}
                {optionNameLabel}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
